/*
 * V·lette Size Guide overlay: scoped to [data-vlette-size-guide-open].
 * Uses the Shopify Page HTML already rendered by product-template.liquid.
 * No Impulse global tooltip or variant event hooks are modified.
 */
(function () {
  'use strict';

  if (window.__vletteSizeGuideInit) return;
  window.__vletteSizeGuideInit = true;

  var activeSheet = null;
  var activeTrigger = null;
  var closeTimer = null;
  var closingSheet = null;
  var animationToken = 0;

  function findParent(element, selector) {
    return element && element.closest ? element.closest(selector) : null;
  }

  function getSheetFromTrigger(trigger) {
    var id = trigger && trigger.getAttribute('aria-controls');
    var sheet = id ? document.getElementById(id) : null;
    return sheet && sheet.matches('[data-vlette-size-guide-sheet]') ? sheet : null;
  }

  function getPanel(sheet) {
    return sheet ? sheet.querySelector('.vlette-size-guide-sheet__panel') : null;
  }

  function showSheet(sheet, trigger) {
    if (!sheet || !trigger) return;

    if (activeSheet && activeSheet !== sheet) {
      hideSheet(activeSheet, false, true);
    }

    window.clearTimeout(closeTimer);
    closeTimer = null;
    closingSheet = null;
    animationToken += 1;
    var thisAnimation = animationToken;

    // Move out of the product layout, avoiding transform and overflow clipping.
    // The ID and selected Shopify Page remain unique to each product instance.
    if (sheet.parentNode !== document.body) {
      document.body.appendChild(sheet);
    }

    if (activeTrigger && activeTrigger !== trigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
    }

    activeSheet = sheet;
    activeTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');

    sheet.hidden = false;
    sheet.setAttribute('aria-hidden', 'false');
    var panel = getPanel(sheet);
    if (panel) panel.scrollTop = 0;
    document.documentElement.classList.add('vlette-size-guide-is-open');

    window.requestAnimationFrame(function () {
      if (animationToken !== thisAnimation || activeSheet !== sheet) return;
      sheet.classList.add('is-visible');
      if (panel) panel.focus({ preventScroll: true });
    });
  }

  function hideSheet(sheet, restoreFocus, immediate) {
    sheet = sheet || activeSheet;
    if (!sheet || sheet.hidden) return;

    window.clearTimeout(closeTimer);
    closeTimer = null;
    animationToken += 1;
    closingSheet = sheet;

    sheet.classList.remove('is-visible');
    sheet.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vlette-size-guide-is-open');

    var trigger = activeTrigger;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    if (restoreFocus !== false && trigger && document.contains(trigger)) {
      trigger.focus({ preventScroll: true });
    }

    if (activeSheet === sheet) {
      activeSheet = null;
      activeTrigger = null;
    }

    function finish() {
      if (closingSheet === sheet && activeSheet !== sheet) {
        sheet.hidden = true;
        closingSheet = null;
      }
      closeTimer = null;
    }

    if (immediate || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      finish();
    } else {
      closeTimer = window.setTimeout(finish, 260);
    }
  }

  function trapFocus(event) {
    if (!activeSheet || activeSheet.hidden || event.key !== 'Tab') return;
    var panel = getPanel(activeSheet);
    if (!panel) return;

    var candidates = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    var focusable = Array.prototype.filter.call(candidates, function (item) {
      return !item.hidden && item.getAttribute('aria-hidden') !== 'true' && item.getClientRects().length > 0;
    });
    if (!focusable.length) {
      event.preventDefault();
      panel.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === panel)) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var trigger = findParent(target, '[data-vlette-size-guide-open]');

    if (trigger) {
      var sheet = getSheetFromTrigger(trigger);
      // Preserve the Page URL as a useful fallback if the overlay isn't present.
      if (!sheet) return;
      event.preventDefault();
      event.stopPropagation();
      showSheet(sheet, trigger);
      return;
    }

    var close = findParent(target, '[data-vlette-size-guide-close]');
    if (close) {
      var parentSheet = findParent(close, '[data-vlette-size-guide-sheet]');
      if (parentSheet && parentSheet === activeSheet) {
        event.preventDefault();
        event.stopPropagation();
        hideSheet(parentSheet, true, false);
      }
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!activeSheet || activeSheet.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      hideSheet(activeSheet, true, false);
      return;
    }
    trapFocus(event);
  });

  // A sheet may have been moved to <body>; remove its old instance if its
  // product section is re-rendered inside Shopify's Theme Editor.
  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    var sheets = document.querySelectorAll('[data-vlette-size-guide-sheet][data-vlette-size-guide-section-id]');
    for (var i = 0; i < sheets.length; i++) {
      var sheet = sheets[i];
      if (sheet.getAttribute('data-vlette-size-guide-section-id') !== String(sectionId)) continue;
      if (sheet === activeSheet) hideSheet(sheet, false, true);
      if (sheet.parentNode === document.body) sheet.remove();
    }
  });
})();
